export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS'
export const ADD_HISTORY_SUCCESS = 'ADD_HISTORY_SUCCESS'
export const UPDATE_HISTORY_SUCCESS = 'UPDATE_HISTORY_SUCCESS'
export const REQUEST = 'REQUEST'
export const FAILURE = 'FAILURE'
